import styled from 'styled-components';

export const Component = styled.button`
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  max-width: 90px;
  padding: 4px 10px 3px 11px;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  border: 1px solid #c6c6c6;
  border-radius: 5px;
  color: #5b5b5b;
`;
type Props = {
  label: string;
  onClick: () => void;
};
export default function ResetButton({ label, onClick }: Props) {
  return <Component onClick={onClick}>{label}</Component>;
}
